import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a555962"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "bus-indicator" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "bus-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      "aria-label": `버스 번호: ${$setup.displayedBusLocation.plateNumber}`,
      class: _normalizeClass(["bus-indicator-container", {
      'bus-indicator-shadow': !$props.isFullSeat && !!$setup.busesImageExisted.length,
      'full-bus-indicator-shadow': $props.isFullSeat && !!$setup.busesImageExisted.length,
      'is-full': $props.isFullSeat,
    }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emitOnClick($setup.busesImageExisted)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.slicePlateNumber($setup.displayedBusLocation.plateNumber ?? "")), 1 /* TEXT */)
        ])
      ])
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    _createCommentVNode(" 펼침/닫힘 기능 삭제 "),
    _createCommentVNode(" <div\n    class=\"bus-indicator-container\"\n    :class=\"{ spread: isSpread, 'is-full': isFullSeat }\"\n    @click=\"toggleCards(!isSpread)\"\n    @transitionend=\"onTransitionEnd\"\n  >\n    <div v-if=\"isBusMultiple\" class=\"bus-indicator-back\"></div>\n\n\n    <div\n      v-for=\"(busLocation, index) in busLocations\"\n      :key=\"index\"\n      :style=\"calculateStyle(index)\"\n      class=\"bus-indicator\"\n    >\n      <div class=\"wrapper\">\n        <span class=\"bus-number\">{{\n          slicePlateNumber(busLocation.plateNumber ?? \"\")\n        }}</span>\n      </div>\n    </div>\n  </div> ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}